import { ref, watch } from 'vue';

export type Theme = 'dark' | 'light';
const STORAGE_KEY = 'tchinquiz.theme';

function detect(): Theme {
  const saved = localStorage.getItem(STORAGE_KEY) as Theme | null;
  if (saved === 'dark' || saved === 'light') return saved;
  if (window.matchMedia?.('(prefers-color-scheme: light)').matches) return 'light';
  return 'dark';
}

const theme = ref<Theme>(detect());
function apply(t: Theme) {
  document.documentElement.setAttribute('data-theme', t);
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', t === 'light' ? '#fff5f8' : '#1a1235');
}
apply(theme.value);
watch(theme, (t) => {
  apply(t);
  localStorage.setItem(STORAGE_KEY, t);
});

export function useTheme() {
  return {
    theme,
    toggle: () => { theme.value = theme.value === 'dark' ? 'light' : 'dark'; },
    set: (t: Theme) => { theme.value = t; },
  };
}
